// Mock data for Premium Doctor Portfolio

export const doctorProfile = {
  name: "Dr. Rajesh Kumar",
  title: "Senior Consultant Cardiologist",
  credentials: "MBBS, MD, DM (Cardiology), FACC",
  experience: 18,
  tagline:
    "Advancing Heart Health Through Evidence-Based Medicine & Compassionate Care",
  bio: "Dr. Rajesh Kumar is a distinguished cardiologist with over 18 years of clinical excellence in treating complex cardiovascular conditions. His patient-centric approach combines cutting-edge medical interventions with preventive cardiology, ensuring optimal outcomes for every individual under his care.",
  philosophy:
    "I believe in empowering patients through education, prevention, and personalized treatment plans. Every heart tells a story, and my mission is to ensure it continues beating strong.",
  languages: ["English", "Hindi", "Telugu"],
  image: "/images/doctor-profile.jpg",
};

export const trustStats = [
  { label: "Years of Experience", value: 18, suffix: "+" },
  { label: "Patients Treated", value: 15000, suffix: "+" },
  { label: "Complex Procedures", value: 3500, suffix: "+" },
  { label: "Success Rate", value: 98, suffix: "%" },
];

export const specializations = [
  {
    title: "Interventional Cardiology",
    description:
      "Advanced procedures including angioplasty, stenting, and cardiac catheterization",
    icon: "Heart",
  },
  {
    title: "Preventive Cardiology",
    description:
      "Comprehensive risk assessment and lifestyle modification programs",
    icon: "Shield",
  },
  {
    title: "Heart Failure Management",
    description:
      "Expert care for chronic heart conditions with evidence-based protocols",
    icon: "Activity",
  },
  {
    title: "Hypertension & Lipid Management",
    description:
      "Personalized treatment plans for blood pressure and cholesterol control",
    icon: "TrendingUp",
  },
  {
    title: "Cardiac Imaging & Diagnostics",
    description:
      "Advanced interpretation of ECG, Echo, stress tests, and cardiac CT/MRI",
    icon: "Scan",
  },
  {
    title: "Second Opinion Consultations",
    description:
      "Comprehensive review of diagnosis and treatment recommendations",
    icon: "FileCheck",
  },
];

export const careerTimeline = [
  {
    year: "2024 - Present",
    role: "Senior Consultant Cardiologist",
    institution: "Apollo Hospitals, Mumbai",
    achievements: [
      "Leading the Advanced Heart Failure Program",
      "Performed 500+ complex interventional procedures",
    ],
  },
  {
    year: "2018 - 2024",
    role: "Consultant Cardiologist",
    institution: "Fortis Hospital, Delhi",
    achievements: [
      "Established preventive cardiology clinic",
      "Published 15+ research papers",
    ],
  },
  {
    year: "2015 - 2018",
    role: "Senior Registrar",
    institution: "AIIMS, New Delhi",
    achievements: [
      "Managed critical cardiac care unit",
      "Training program coordinator",
    ],
  },
  {
    year: "2012 - 2015",
    role: "Registrar - Cardiology",
    institution: "PGI Chandigarh",
    achievements: ["Completed DM in Cardiology", "Best resident award 2014"],
  },
];

export const education = [
  {
    degree: "Fellowship (FACC)",
    institution: "American College of Cardiology",
    year: "2020",
    type: "fellowship",
  },
  {
    degree: "DM (Cardiology)",
    institution: "PGI Chandigarh",
    year: "2015",
    type: "specialization",
  },
  {
    degree: "MD (General Medicine)",
    institution: "AIIMS, New Delhi",
    year: "2010",
    type: "postgraduate",
  },
  {
    degree: "MBBS",
    institution: "Maulana Azad Medical College, Delhi",
    year: "2007",
    type: "undergraduate",
  },
];

export const services = [
  {
    title: "Concierge Cardiology Consultation",
    description:
      "Extended one-on-one consultations with comprehensive cardiac assessment and personalized care plans",
    duration: "60 minutes",
    features: [
      "Detailed health history review",
      "Advanced diagnostic interpretation",
      "Personalized treatment roadmap",
    ],
  },
  {
    title: "Executive Health Check",
    description:
      "Comprehensive cardiovascular screening designed for busy professionals",
    duration: "Half day",
    features: [
      "Complete cardiac workup",
      "Stress management evaluation",
      "Preventive care planning",
    ],
  },
  {
    title: "Second Opinion Services",
    description:
      "Expert review of your diagnosis, test results, and treatment recommendations",
    duration: "45 minutes",
    features: [
      "Detailed case review",
      "Alternative treatment options",
      "Written medical opinion",
    ],
  },
  {
    title: "Corporate Wellness Programs",
    description: "Tailored cardiovascular health programs for organizations",
    duration: "Customized",
    features: [
      "On-site health screenings",
      "Employee education sessions",
      "Risk stratification reports",
    ],
  },
];

export const testimonials = [
  {
    name: "Amit Sharma",
    age: 52,
    condition: "Post-Angioplasty Care",
    text: "Dr. Kumar not only saved my life but gave me the confidence to live it fully. His thorough explanations and genuine care made all the difference during my recovery.",
    rating: 5,
  },
  {
    name: "Priya Mehta",
    age: 45,
    condition: "Preventive Cardiology",
    text: "I came to Dr. Kumar for a routine checkup and discovered risk factors I never knew existed. His preventive approach has transformed my health and given me peace of mind.",
    rating: 5,
  },
  {
    name: "Rajiv Patel",
    age: 58,
    condition: "Heart Failure Management",
    text: "After struggling with heart failure for years, Dr. Kumar's comprehensive treatment plan has significantly improved my quality of life. I'm grateful for his expertise and compassion.",
    rating: 5,
  },
  {
    name: "Sanjana Reddy",
    age: 41,
    condition: "Hypertension Management",
    text: "Dr. Kumar took the time to understand my lifestyle and created a personalized plan that actually works. My blood pressure is now under control without feeling overwhelmed.",
    rating: 5,
  },
];

export const publications = [
  {
    title: "Novel Approaches in Acute Coronary Syndrome Management",
    journal: "Indian Heart Journal",
    year: 2023,
    type: "Research Paper",
  },
  {
    title: "Preventive Cardiology in the Digital Age",
    conference: "Cardiological Society of India Annual Conference",
    year: 2023,
    type: "Keynote Speaker",
  },
  {
    title: "Optimizing Outcomes in Complex PCI Procedures",
    journal: "Journal of Interventional Cardiology",
    year: 2022,
    type: "Research Paper",
  },
  {
    title: "Heart Health in Urban India: Challenges and Solutions",
    media: "Times of India - Health Section",
    year: 2024,
    type: "Media Feature",
  },
];

export const locations = [
  {
    name: "Apollo Hospitals - Primary Clinic",
    address: "Sahar Road, Andheri East, Mumbai - 400099",
    phone: "+91 98765 43210",
    email: "appointments@drkumar.clinic",
    timings: [
      { days: "Monday - Friday", hours: "2:00 PM - 6:00 PM" },
      { days: "Saturday", hours: "10:00 AM - 2:00 PM" },
    ],
    mapUrl: "https://images.unsplash.com/photo-1739285388427-d6f85d12a8fc",
  },
  {
    name: "Fortis Hospital - Specialty Clinic",
    address: "Mulund Goregaon Link Road, Mumbai - 400078",
    phone: "+91 98765 43211",
    email: "fortis@drkumar.clinic",
    timings: [{ days: "Tuesday & Thursday", hours: "10:00 AM - 1:00 PM" }],
    mapUrl:
      "https://images.pexels.com/photos/35260725/pexels-photo-35260725.jpeg",
  },
];
